/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_INFO_FIELDS_ADD
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Added Manufacturer and SKU (Part Number) fields to BroadcastInformation display.
 * Positioned between Category and Condition as requested.
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcast-details/components/BroadcastInformation.tsx
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    FIGMA_COLLECTION_DESIGN
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Implemented "Description" and "Data from collection" sections as separate boxes 
 * following Figma design node 570-6914. Updated typography to P1 18 semi-bold.
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcast-details/BroadcastDetailsPage.tsx
 */

import React from "react";
import { BroadcastItemData } from "../interfaces/broadcastDetail";
// [2026-02-13] CURRENCY_PHASE2: Centralized single-price display
import { formatCurrency } from "../../../../../utils/priceDisplay";
import styles from "./BroadcastInformation.module.scss";

// [2025-12-29] Broadcast details: Item specification display component

interface BroadcastInformationProps {
  item: BroadcastItemData;
}

const BroadcastInformation: React.FC<BroadcastInformationProps> = ({ item }) => {
  // [2025-12-29] Format categories array
  const formatCategories = (categories?: string[]) => {
    if (!categories || categories.length === 0) return "—";
    return categories.join(", ");
  };

  return (
    <div className={styles["broadcast-information-container"]}>
      {/* Box 1: Broadcast Information (Main Fields) */}
      <div className={styles["broadcast-information"]}>
        

        <div className={styles["broadcast-information__fields-list"]}>
          {/* Category */}
          {item.categories && item.categories.length > 0 && (
            <div className={styles["broadcast-information__field"]}>
              <label className={styles["broadcast-information__label"]}>Category:</label>
              <span className={styles["broadcast-information__value"]}>{formatCategories(item.categories)}</span>
            </div>
          )}

          {/* [2025-12-29] Manufacture and SKU: added specification fields */}
          <div className={styles["broadcast-information__field"]}>
            <label className={styles["broadcast-information__label"]}>Manufacturer:</label>
            <span className={styles["broadcast-information__value"]}>{item.manufacturer || "—"}</span>
          </div>

          <div className={styles["broadcast-information__field"]}>
            <label className={styles["broadcast-information__label"]}>SKU:</label>
            <span className={styles["broadcast-information__value"]}>{item.partNumber || "—"}</span>
          </div>

          {/* Condition */}
          <div className={styles["broadcast-information__field"]}>
            <label className={styles["broadcast-information__label"]}>Condition:</label>
            <span className={styles["broadcast-information__value"]}>{item.condition || "—"}</span>
          </div>

          {/* Quantity */}
          <div className={styles["broadcast-information__field"]}>
            <label className={styles["broadcast-information__label"]}>Quantity:</label>
            <span className={styles["broadcast-information__value"]}>{item.quantity}</span>
          </div>

          {/* Price */}
          <div className={styles["broadcast-information__field"]}>
            <label className={styles["broadcast-information__label"]}>Price:</label>
            <span className={styles["broadcast-information__value"]}>
              {formatCurrency(item.price, item.currency, (item as any).convertedPrice, (item as any).displayCurrency) || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Box 2: Description */}
      {item.description && (
        <div className={styles["broadcast-information"]}>
          <div className={styles["broadcast-information__header"]}>
            <h2 className={styles["broadcast-information__title"]}>Description</h2>
          </div>
          {/* <div className={styles["broadcast-information__divider"]}>
            <div className={styles["broadcast-information__divider-line"]} />
          </div> */}
          <div className={styles["broadcast-information__description-text"]}>
            {item.description}
          </div>
        </div>
      )}

      
      
    </div>
  );
};

export default BroadcastInformation;
